exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barestho-login {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--main-blue);\n}\n\n.barestho-login-title img {\n    width: 100%;\n}\n\n.barestho-login-container {\n    width: 80%;\n}\n\n@media (min-width: 500px) {\n    .barestho-login-container {\n        width: 400px;\n    }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/containers/Authentication/Authentication.css
// module id = 2111
// module chunks = 29 30